import { BadgeCheck, CalendarCheck, FileSignature } from "lucide-react";
import { useSponsorshipBareme } from "@/features/sponsorship/hooks/useSponsorshipBareme";
import type { SponsorshipPointsScale } from "@/features/sponsorship/types/sponsorship.type";
import { P } from "@/shared/ui/typographies/paragraph";
import type { LucideIcon } from "lucide-react";

type StepDefinition = {
  icon: LucideIcon
  scaleKey: keyof SponsorshipPointsScale
  title: string
  description: string
};

const STEP_DEFINITIONS: StepDefinition[] = [
  {
    icon: BadgeCheck,
    scaleKey: "cse_qualifie",
    title: "Le CSE est qualifié",
    description: "Vous recommandez un contact en 2 minutes. Dès qu'il est validé comme interlocuteur CSE pertinent, vos premiers points tombent.",
  },
  {
    icon: CalendarCheck,
    scaleKey: "rdv_confirme",
    title: "Le rendez-vous est confirmé",
    description: "Votre contact confirme un rendez-vous avec nos équipes — vos points s'accumulent à chaque étape.",
  },
  {
    icon: FileSignature,
    scaleKey: "signe",
    title: "Le contrat est signé",
    description: "Le jackpot : la signature crédite le plus gros total de points de la recommandation.",
  },
];

export const ThreeStepPath = () => {
  const bareme = useSponsorshipBareme();
  const steps = STEP_DEFINITIONS.map((step) => ({
    ...step,
    gain: `+${bareme.pointsScale[step.scaleKey].toLocaleString("fr-FR")} pts`,
  }));

  return (
    <ol className="grid gap-4 md:grid-cols-3">
      {steps.map((step) => (
        <li
          key={step.title}
          className="flex flex-col gap-2 rounded-2xl bg-white px-5 py-5 shadow-sm dark:bg-gray-800"
        >
          <div className="flex items-center justify-between">
            <span className="inline-flex size-10 items-center justify-center rounded-full bg-violet-100 text-violet-700 dark:bg-violet-900/60 dark:text-violet-300">
              <step.icon size={20} aria-hidden />
            </span>
            <span className="rounded-full bg-emerald-100 px-3 py-1 text-xs font-bold text-emerald-800 dark:bg-emerald-900/60 dark:text-emerald-200">
              {step.gain}
            </span>
          </div>
          <P className="font-semibold text-gray-900 dark:text-white">{step.title}</P>
          <P size="sm" className="text-gray-600 dark:text-gray-400">{step.description}</P>
        </li>
      ))}
    </ol>
  );
};

ThreeStepPath.displayName = "ThreeStepPath";
